import DisplayQueueStatus from "../../components/DisplayQueueStatus";

const DisplayQueueStatusPage = () => {
  return <DisplayQueueStatus />;
};

export default DisplayQueueStatusPage;
